import { FormControl } from "@mui/material";
import SelectUI from "./SelectUI.jsx";

const SelectWithInput = (props) => {
  return (
    <FormControl sx={{ m: 1, minWidth: 120 }}>
      <SelectUI {...props} />
    </FormControl>
  );
};

export default SelectWithInput;